export default __webpack_public_path__ + "static/media/image5.1f294d0d.png";